import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useImportExportButtonStyles = makeStyles(
  (theme: Theme) => ({
    button: {
      backgroundColor: '#2EFFAF',
      borderRadius: '100px',
      padding: '.5rem .75rem',
      boxShadow: 'none',
      '&--outlined': {
        backgroundColor: 'transparent',
        border:
          theme.palette?.mode === 'dark'
            ? '1px solid #00FF9D'
            : '1px solid #00A868',
        '&:hover': {
          backgroundColor: 'transparent',
          border:
            theme.palette?.mode === 'dark'
              ? '1px solid #00FF9D'
              : '1px solid #00A868',
        },
      },
      '&:hover': {
        backgroundColor: '#2EFFAF',
      },
      '& .v5-MuiButton-startIcon': {
        margin: '0',
        color: theme.palette?.mode === 'dark' ? '#fff' : '#74757E',
      },
    },
    text: {
      textTransform: 'none',
      color: '#005736',
      fontSize: '.875rem',
      fontWeight: 'bold',
      '&--outlined': {
        color: theme.palette?.mode === 'dark' ? '#fff' : '#74757E',
      },
    },
  }),
  { name: 'ImportExportButton' },
);
